import { render, staticRenderFns } from "./RuleCustomList.vue?vue&type=template&id=7c911612&scoped=true&"
import script from "./RuleCustomList.vue?vue&type=script&lang=js&"
export * from "./RuleCustomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c911612",
  null
  
)

export default component.exports